import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { isPlatformAdminRole } from '../lib/platformAdminAccess'
import { getStoredAccessToken } from '../services/api'

export function ProtectedRoute({ children }) {
  const { isAuthenticated, user } = useAuth()
  const location = useLocation()
  const hasAccessToken = Boolean(getStoredAccessToken())

  if (!isAuthenticated || !hasAccessToken || !isPlatformAdminRole(user?.role)) {
    return <Navigate to="/login" replace state={{ from: location }} />
  }

  return children
}
